import { createContext } from 'react';

const SearchContext = createContext(null);

export default SearchContext;
